import React, { useContext, useEffect, useState } from 'react';
import WebWidgeMapView from './views/WebWidgetMapView';
import AlertList from './components/AlertList/AlertList';
import api from './api';
import { ApiResponse } from './api';
import { WebWidgetContext, WebWidgetProvider, WEB_WIDGET_ACTIONS } from './context';
import I18N, { getMessages, I18NProvider } from './common/I18N'

import './App.scss';
import Loading from './components/Loading/loading';
import { Modal } from 'react-bootstrap';

function Main() {
  const [enableMapDisplay, setMapDisplay] = useState(true)
  const {
    lang,
    autoExpand,
    orgId,
    stream,
    state: {
      loadingSettings,
      loadingAlertDetail,
      showNoShapeMessage,
    },
    actionDispatch
  } = useContext(WebWidgetContext);

  const handleClose = () => {
    actionDispatch(WEB_WIDGET_ACTIONS.HIDE_NO_SHAPE_MSG, false);
  };

  const getMapDisplay = async () => {
    try {
      let { data: { enableMapDisplay }  }: ApiResponse = await api.getMessages(orgId, 0, stream);
      if (enableMapDisplay === undefined) enableMapDisplay = true
      setMapDisplay(enableMapDisplay)
    } catch {
      setMapDisplay(true)
    }
  }

  useEffect(() => {
    getMapDisplay()
  }, [])


  return loadingSettings ? <Loading className="full-page-loading" /> : (
    <I18NProvider i18nContext={getMessages(lang)}>
      <div className="App">
        {
          loadingAlertDetail && <Loading className="full-page-loading" />
        }
        <AlertList isOpen={autoExpand} enableMapDisplay={enableMapDisplay} />
        {enableMapDisplay && <WebWidgeMapView />}
        <Modal
          show={showNoShapeMessage}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          className='no-shape-msg-modal'
        >
          <Modal.Header closeButton>
            <div className="powerby-logo">
              <div><I18N>web.widget.powered.by</I18N></div>
              <div>
                <i className="evbg-logo"></i>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="text-center font-weight-bold">
            <I18N>web.widget.no.polygon</I18N>
          </Modal.Body>
        </Modal>
      </div>
    </I18NProvider>
  );
}

function App() {
  return (
    <WebWidgetProvider>
      <Main />
    </WebWidgetProvider>
  );
}

export default App;
